<div class="shipping-rate-selector-compact">
  <!-- Shipping Rate Section -->
  <div class="shipping-rate-section">
    <!-- Auto Rate Enabled Display -->
    <div
      *ngIf="formGroup.controls.enableAutoShippingRate.value"
      class="auto-rate-active"
    >
      <div class="auto-rate-info">
        <i class="pi pi-check-circle"></i>
        <div class="auto-rate-content">
          <span class="auto-rate-label">Automatic Rate Selection Enabled</span>
          <span class="auto-rate-description">
            Lowest cost rate will be selected:
            <strong>
              {{
                shippingRateOptions && shippingRateOptions.length > 0
                  ? getDefaultShippingRate()?.OptionText || "No rate available"
                  : "No rate available"
              }}
            </strong>
          </span>
        </div>
      </div>
    </div>

    <!-- Manual Rate Selection Mode (Dropdown) -->
    <div
      *ngIf="!formGroup.controls.enableAutoShippingRate.value"
      class="manual-rate-mode"
    >
      <div class="field-compact">
        <label for="shipping-rate-select" class="field-label">
          <i class="pi pi-box"></i>
          Select Shipping Rate<span *ngIf="required" class="required">*</span>
        </label>
        <p-select
          inputId="shipping-rate-select"
          [options]="selectOptions"
          [formControl]="formGroup.controls.preferredShippingRateOption"
          (onChange)="onShippingRateChange($event)"
          [disabled]="disabled"
          placeholder="Choose a shipping rate..."
          styleClass="w-full"
          appendTo="body"
          [filter]="true"
          filterPlaceholder="Search rates..."
          [showClear]="false"
          [virtualScroll]="selectOptions.length > 10"
          [virtualScrollItemSize]="38"
        >
          <ng-template pTemplate="selectedItem" let-selectedOption>
            <div class="selected-rate-display" *ngIf="selectedOption">
              <i class="pi pi-box"></i>
              <span>{{ selectedOption.label }}</span>
              <span
                *ngIf="isDefaultRate(selectedOption.value)"
                class="badge-default"
              >
                Default
              </span>
            </div>
          </ng-template>
          <ng-template let-option pTemplate="item">
            <div class="rate-option-item">
              <div class="rate-option-content">
                <i class="pi pi-box"></i>
                <span class="rate-name">{{ option.label }}</span>
              </div>
              <span *ngIf="isDefaultRate(option.value)" class="badge-default">
                Default
              </span>
            </div>
          </ng-template>
        </p-select>

        <!-- Error Message -->
        <small
          *ngIf="
            required && !formGroup.controls.preferredShippingRateOption.value
          "
          class="error-message"
        >
          <i class="pi pi-exclamation-triangle"></i>
          Please select a shipping rate
        </small>

        <!-- No Rates Available Warning -->
        <small
          *ngIf="selectOptions.length === 0 && !isLoading"
          class="info-message"
        >
          <i class="pi pi-info-circle"></i>
          No shipping rates available. Enable automatic selection or add rates.
        </small>
      </div>
    </div>
  </div>

  <!-- Auto Shipping Rate Toggle -->
  <div class="auto-rate-toggle">
    <p-checkbox
      inputId="auto-shipping-rate"
      [formControl]="formGroup.controls.enableAutoShippingRate"
      (onChange)="onAutoShippingRateToggle()"
      [disabled]="disabled"
      [binary]="true"
    />
    <label for="auto-shipping-rate" class="toggle-label">
      Automatically select the lowest cost shipping rate
    </label>
  </div>
</div>
